// Standard (built-in) fields shown in the contact, company and deal forms,
// listed in the order they appear today. `fullWidth` items span both columns.
// Labels reuse the i18n keys the forms already render. `group` drives the
// section header shown above the first field of each contiguous run of the
// same group in the (possibly user-reordered) field list.
export const STANDARD_FIELDS = {
  product: [
    { key: 'sku', labelKey: 'PRODUCTS.FIELDS.SKU' },
    { key: 'product_group_id', labelKey: 'PRODUCTS.FIELDS.GROUP' },
    { key: 'price', labelKey: 'PRODUCTS.FIELDS.PRICE' },
    { key: 'description', labelKey: 'PRODUCTS.FIELDS.DESCRIPTION' },
    { key: 'unit', labelKey: 'PRODUCTS.FIELDS.UNIT' },
    { key: 'special_price', labelKey: 'PRODUCTS.FIELDS.SPECIAL_PRICE' },
    { key: 'wholesale_price', labelKey: 'PRODUCTS.FIELDS.WHOLESALE_PRICE' },
    { key: 'loyalty_points', labelKey: 'PRODUCTS.FIELDS.LOYALTY_POINTS' },
    { key: 'image', labelKey: 'PRODUCTS.FIELDS.IMAGE' },
  ],
  contact: [
    {
      key: 'labels',
      labelKey: 'CONTACTS_LAYOUT.CARD.LABELS_FORM.TITLE',
      group: 'labels',
      fullWidth: true,
    },
    {
      key: 'first_name',
      labelKey: 'CONTACTS_LAYOUT.CARD.EDIT_DETAILS_FORM.FORM.FIRST_NAME.LABEL',
      group: 'details',
    },
    {
      key: 'last_name',
      labelKey: 'CONTACTS_LAYOUT.CARD.EDIT_DETAILS_FORM.FORM.LAST_NAME.LABEL',
      group: 'details',
    },
    {
      key: 'birth_date',
      labelKey: 'CONTACTS_LAYOUT.CARD.EDIT_DETAILS_FORM.FORM.BIRTH_DATE.LABEL',
      group: 'details',
    },
    {
      key: 'gender',
      labelKey: 'CONTACTS_LAYOUT.CARD.EDIT_DETAILS_FORM.FORM.GENDER.LABEL',
      group: 'details',
    },
    {
      key: 'email',
      labelKey:
        'CONTACTS_LAYOUT.CARD.EDIT_DETAILS_FORM.FORM.EMAIL_ADDRESS.LABEL',
      group: 'details',
    },
    {
      key: 'phone_number',
      labelKey:
        'CONTACTS_LAYOUT.CARD.EDIT_DETAILS_FORM.FORM.PHONE_NUMBER.LABEL',
      group: 'details',
    },
    {
      key: 'country',
      labelKey: 'CONTACTS_LAYOUT.CARD.EDIT_DETAILS_FORM.FORM.COUNTRY.LABEL',
      group: 'details',
    },
    {
      key: 'zip_code',
      labelKey: 'CONTACTS_LAYOUT.CARD.EDIT_DETAILS_FORM.FORM.ZIP_CODE.LABEL',
      group: 'details',
    },
    {
      key: 'state',
      labelKey: 'CONTACTS_LAYOUT.CARD.EDIT_DETAILS_FORM.FORM.STATE.LABEL',
      group: 'details',
    },
    {
      key: 'city',
      labelKey: 'CONTACTS_LAYOUT.CARD.EDIT_DETAILS_FORM.FORM.CITY.LABEL',
      group: 'details',
    },
    {
      key: 'bio',
      labelKey: 'CONTACTS_LAYOUT.CARD.EDIT_DETAILS_FORM.FORM.BIO.LABEL',
      group: 'details',
    },
    {
      key: 'social_profiles',
      labelKey: 'CONTACTS_LAYOUT.CARD.SOCIAL_MEDIA.TITLE',
      group: 'social_profiles',
      fullWidth: true,
    },
  ],
  company: [
    {
      key: 'labels',
      labelKey: 'COMPANIES_LAYOUT.LABELS.TITLE',
      group: 'labels',
      fullWidth: true,
    },
    {
      key: 'name',
      labelKey: 'COMPANIES_LAYOUT.CARD.EDIT_DETAILS_FORM.FORM.NAME.LABEL',
      group: 'details',
    },
    {
      key: 'domain',
      labelKey: 'COMPANIES_LAYOUT.CARD.EDIT_DETAILS_FORM.FORM.DOMAIN.LABEL',
      group: 'details',
    },
    {
      key: 'email',
      labelKey: 'COMPANIES_LAYOUT.CARD.EDIT_DETAILS_FORM.FORM.EMAIL.LABEL',
      group: 'details',
    },
    {
      key: 'phone_number',
      labelKey:
        'COMPANIES_LAYOUT.CARD.EDIT_DETAILS_FORM.FORM.PHONE_NUMBER.LABEL',
      group: 'details',
    },
    {
      key: 'cnpj',
      labelKey: 'COMPANIES_LAYOUT.CARD.EDIT_DETAILS_FORM.FORM.CNPJ.LABEL',
      group: 'details',
    },
    {
      key: 'city',
      labelKey: 'COMPANIES_LAYOUT.CARD.EDIT_DETAILS_FORM.FORM.CITY.LABEL',
      group: 'details',
    },
    {
      key: 'country',
      labelKey: 'COMPANIES_LAYOUT.CARD.EDIT_DETAILS_FORM.FORM.COUNTRY.LABEL',
      group: 'details',
    },
    {
      key: 'description',
      labelKey:
        'COMPANIES_LAYOUT.CARD.EDIT_DETAILS_FORM.FORM.DESCRIPTION.LABEL',
      group: 'details',
      fullWidth: true,
    },
    {
      key: 'social_profiles',
      labelKey: 'COMPANIES_LAYOUT.CARD.SOCIAL_MEDIA.TITLE',
      group: 'social_profiles',
      fullWidth: true,
    },
  ],
  deal: [
    { key: 'labels', labelKey: 'DEALS.LABELS.TITLE', fullWidth: true },
    { key: 'contact', labelKey: 'DEALS.CREATE.FIELDS.CONTACT' },
    { key: 'company', labelKey: 'DEALS.CREATE.FIELDS.COMPANY' },
    {
      key: 'pipeline_stage',
      labelKey: 'DEALS.CREATE.FIELDS.STAGE',
      fullWidth: true,
    },
    { key: 'name', labelKey: 'DEALS.CREATE.FIELDS.NAME' },
    { key: 'value', labelKey: 'DEALS.CREATE.FIELDS.VALUE' },
    { key: 'currency', labelKey: 'DEALS.CREATE.FIELDS.CURRENCY' },
    { key: 'assigned_to', labelKey: 'DEALS.CREATE.FIELDS.ASSIGNED_TO' },
    {
      key: 'products_of_interest',
      labelKey: 'DEALS.CREATE.FIELDS.PRODUCTS_OF_INTEREST',
    },
    {
      key: 'last_purchase_at',
      labelKey: 'DEALS.CREATE.FIELDS.LAST_PURCHASE_AT',
    },
  ],
};

// Campos do contato que a automação de conversão envia ao píxel das plataformas de Ads, já no
// formato exigido por elas (ver AutomationFlows::MetaConversionPayload).
export const PIXEL_ADAPTED_CONTACT_FIELDS = [
  'first_name',
  'last_name',
  'birth_date',
  'gender',
  'email',
  'phone_number',
  'country',
  'zip_code',
  'state',
  'city',
];

// Section header title per `group`, shown above the first field of each
// contiguous run of that group. Models/groups missing here render no header
// (e.g. custom fields, which have no group and can sit anywhere in the order).
export const FIELD_GROUP_TITLE_KEYS = {
  contact: {
    labels: 'CONTACTS_LAYOUT.CARD.LABELS_FORM.TITLE',
    details: 'CONTACTS_LAYOUT.CARD.EDIT_DETAILS_FORM.TITLE',
    social_profiles: 'CONTACTS_LAYOUT.CARD.SOCIAL_MEDIA.TITLE',
  },
  company: {
    labels: 'COMPANIES_LAYOUT.LABELS.TITLE',
    details: 'COMPANIES_LAYOUT.CARD.EDIT_DETAILS_FORM.TITLE',
    social_profiles: 'COMPANIES_LAYOUT.CARD.SOCIAL_MEDIA.TITLE',
  },
};
